module.exports = __webpack_public_path__ + "img/hover_icon_proposal_process.23119a6c.svg";